var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployeeinfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8197_25355)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 16,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#DEEFEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.2,
    y: 16.2,
    width: 49.6,
    height: 49.6,
    rx: 24.8,
    stroke: "#E2E2E8",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7606 55.3359C54.7606 50.9853 49.1175 47.4583 42.1564 47.4583C35.1953 47.4583 29.5522 50.9853 29.5522 55.3359M42.1564 42.7318C37.8057 42.7318 34.2788 39.2048 34.2788 34.8542C34.2788 30.5035 37.8057 26.9766 42.1564 26.9766C46.5071 26.9766 50.034 30.5035 50.034 34.8542C50.034 39.2048 46.5071 42.7318 42.1564 42.7318Z",
    stroke: "#00685F",
    strokeWidth: 1.8006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 44,
    width: 13.25,
    height: 13.25,
    rx: 6.625,
    fill: "#08C108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7777 54V48.8933H53.1455V54H51.7777ZM52.4667 48.1942C52.2235 48.1942 52.0208 48.1232 51.8587 47.9814C51.7033 47.8328 51.6257 47.647 51.6257 47.4241C51.6257 47.2012 51.7033 47.0188 51.8587 46.877C52.0208 46.7283 52.2235 46.654 52.4667 46.654C52.7166 46.654 52.9192 46.7283 53.0746 46.877C53.2367 47.0188 53.3178 47.2012 53.3178 47.4241C53.3178 47.647 53.2367 47.8328 53.0746 47.9814C52.9192 48.1232 52.7166 48.1942 52.4667 48.1942Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8197_25355",
    x: 0,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8197_25355"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8197_25355",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeinfo);
export default __webpack_public_path__ + "static/media/employeeinfo.1e70d8b45becef11b4773613297dec55.svg";
export { ForwardRef as ReactComponent };